import { Component, Input } from '@angular/core';
import { iSignalFormField } from '../../../core/functions/signal-form-field';

export interface RadioOption<TValue> {
  label: string;
  value: TValue;
}

@Component({
  standalone: true,
  selector: 'app-signal-input',
  imports: [],
  templateUrl: './signal-input.component.html',
  styleUrl: './signal-input.component.scss',
})
export class SignalInputComponent<TValue> {
  @Input({ required: true }) field!: iSignalFormField<TValue>;
  @Input() options: RadioOption<TValue>[] = [];
  @Input() name: string = 'radio_group_' + Math.random().toString(36).substring(2, 9);

  @Input() type: string = 'text';
  @Input() placeholder: string = '';

  @Input() formatted: boolean = false;

  // converts input string into TValue
  @Input() parse: (value: string) => TValue = (value) => value as unknown as TValue;

  // pass in 'new-password' to shut off the auto complete and protect against incorrect information being filled out
  @Input() autocomplete: string | null = null;

  @Input() disabled: boolean = false;
  @Input() maxLength: number | null = null;
  @Input() digitsOnly: boolean = false;

  onInput(value: string | TValue): void {
    this.field.setDisplayValue(String(value));
  }

  onTextInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (this.digitsOnly) {
      value = value.replace(/\D/g, '');

      if (this.maxLength !== null) {
        value = value.slice(0, this.maxLength);
      }

      input.value = value;
    }

    this.onInput(value);

    if (this.formatted) {
      input.value = this.field.displayValue();
    }
  }
}
